var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
export var defaultState = {};
var AccountCardContext = createContext({
    state: defaultState,
});
AccountCardContext.displayName = "AccountCardContext";
export var useAccountCardContext = function () {
    var value = useContext(AccountCardContext);
    if (!value) {
        throw new Error("No context value");
    }
    return value;
};
var AccountCardContextProvider = function (_a) {
    var initialState = _a.initialState, children = _a.children;
    var contextValue = useMemo(function () {
        return { state: initialState };
    }, [initialState]);
    return (_jsx(AccountCardContext.Provider, __assign({ value: contextValue }, { children: children })));
};
export default AccountCardContextProvider;
//# sourceMappingURL=AccountCardContext.js.map